module.exports = __webpack_public_path__ + "static/media/A6.b3bc20ce.jpg";